/**
 * SmartAssistBridge — Shared context between Admin UI pages and SmartAssist.
 *
 * Any page in the admin UI can call `updatePageContext({ goldenId, pageName, ... })`
 * and SmartAssist will react to those changes (e.g. auto-set goldenId for EID queries).
 */
import React, { createContext, useContext, useState, useCallback } from "react";

const BridgeContext = createContext({
  pageContext: {},
  updatePageContext: () => {},
});

export const useSmartAssistBridge = () => useContext(BridgeContext);

export default function SmartAssistBridge({ children }) {
  const [pageContext, setPageContext] = useState({
    goldenId: null,
    pageName: null,
    pageData: null,
    previewMode: false,
    overrideRequest: null,
    previewGoldenId: null,
  });

  const updatePageContext = useCallback((updates) => {
    setPageContext((prev) => ({ ...prev, ...updates }));
  }, []);

  return (
    <BridgeContext.Provider value={{ pageContext, updatePageContext }}>
      {children}
    </BridgeContext.Provider>
  );
}
